<template>
  <div>
    <the-college />
    <the-college-course />
    <the-career-system />
    <the-entry :data="entry" gray />
  </div>
</template>

<script>
import TheCollege from '@/components/TheCollege'
import TheCollegeCourse from '@/components/TheCollegeCourse'
import TheCareerSystem from '@/components/TheCareerSystem'
import TheEntry from '@/components/TheEntry'

export default {
  components: { TheCollege, TheCollegeCourse, TheCareerSystem, TheEntry },
  data() {
    return { entry: ['society', 'campus', 'benefit', 'life'] }
  },
}
</script>
